import { Permission, Workspace, WorkspacesListingItem } from '@futrli-sdk/workspaces';
import { withErrorBoundary, WithErrorBoundaryProps } from '@futrli/errors';
import {
  getParamFromRoute,
  getWorkspaceById,
  ROUTE_PARAMS,
  workspaceByIdSelector,
  workspacesSelector
} from '@futrli/shared-services';
import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { StoreState } from '../../core/redux-utils/types';
import { WorkspacePredictSettingsNavBar } from '../components/workspace-predict-settings-navbar';

interface RouterProps {
  params: Record<string, string | undefined>;
}

interface StateToProps {
  readonly permissions: Permission[] | null;
  readonly workspaces: Workspace[] | WorkspacesListingItem[] | null;
  readonly workspaceById: Workspace | WorkspacesListingItem | null;
}

interface DispatchToProps {
  readonly getWorkspaceById: typeof getWorkspaceById;
}

type Props = RouterProps & StateToProps & DispatchToProps & WithErrorBoundaryProps;

export class WorkspaceSettingsNavBarContainerBase extends React.PureComponent<Props> {
  public componentDidMount(): void {
    const { params, workspaceById } = this.props;
    const id: string = getParamFromRoute(params, ROUTE_PARAMS.WORKSPACE_ID) as string;

    if (!workspaceById || workspaceById.id !== id) {
      this.props.getWorkspaceById(id);
    }
  }

  public render() {
    const { workspaceById, workspaces, permissions } = this.props;

    if (!workspaces || !workspaceById || !permissions) {
      return <React.Fragment />;
    }

    return (
      <WorkspacePredictSettingsNavBar
        permissions={permissions}
        workspaces={workspaces as WorkspacesListingItem[]}
        workspace={workspaceById as WorkspacesListingItem}
      />
    );
  }
}

const mapStateToProps = (state: StoreState, ownProps: RouterProps): StateToProps => {
  const workspaceId = getParamFromRoute(ownProps.params, ROUTE_PARAMS.WORKSPACE_ID) as string;
  const { normalised } = state;

  const storedWorkspace = workspaceByIdSelector(normalised, workspaceId);
  let storedPermissions: Permission[] | null = [];

  storedPermissions = storedWorkspace ? (storedWorkspace as WorkspacesListingItem).permissions : null;

  return {
    permissions: storedPermissions,
    workspaces: workspacesSelector(normalised),
    workspaceById: storedWorkspace
  };
};

export const WorkspaceSettingsNavBarContainerBaseWE = withErrorBoundary(WorkspaceSettingsNavBarContainerBase);
export const WorkspaceSettingsNavBarContainerWS = connect(mapStateToProps, {
  getWorkspaceById
})(WorkspaceSettingsNavBarContainerBaseWE);

export const WorkspaceSettingsNavBarContainer: React.FC = () => {
  const params = useParams();
  return <WorkspaceSettingsNavBarContainerWS params={params} />;
};
